import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useIntl } from 'react-intl';
import classNames from 'classnames';
import { getAgeBucket } from './helpers';
import messages from './messages';
const AgeBadge = ({ daysOverdue }) => {
    const intl = useIntl();
    const bucket = getAgeBucket(daysOverdue);
    return (_jsx("span", Object.assign({ className: classNames('age-badge', `age-${bucket}`) }, { children: daysOverdue >= 0
            ? intl.formatMessage(messages.DaysShort, { days: daysOverdue })
            : intl.formatMessage(messages.DueInDays, { days: -daysOverdue }) })));
};
export default AgeBadge;
